import { api } from 'common';

import { RealTimeEligibilityFormFields } from './FormFields';
import { realTimeEligibilityDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const realTimeEligibilityConfig: BlockConfigProps<
  api.FlowDefinition.RealTimeEligibilityBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'realTimeEligibility',
  defaultConfig: {
    patientInsuranceInformationId: '',
    npi: '',
  },
  configFields: {
    schema: api.FlowDefinition.RealTimeEligibilityBlockSchema,
    FormFields: RealTimeEligibilityFormFields,
  },
  documentationMarkdown: realTimeEligibilityDocumentation,
};
